import { render, staticRenderFns } from "./loancharges.vue?vue&type=template&id=716e7764"
import script from "./loancharges.vue?vue&type=script&lang=js"
export * from "./loancharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports